import localforage from "localforage";
import config from "../../config";

export default {
  codeListStore: localforage.createInstance({name: config.prefixes.sysCodeList}),
  codeTreeStore: localforage.createInstance({name: config.prefixes.sysCodeTree}),
  ajaxStore: localforage.createInstance({name: config.prefixes.ajax})
};
